import React, { useState } from "react";
import {
  FaFileAlt,
  FaFileDownload,
  FaSignature,
  FaUserPlus,
} from "react-icons/fa";
import "./DashBoard.css";
import ConsentModal from "./../Modals/ConsentFormModal/ConsentModal";
import RequestPanel from "./../../../components/RequestPanel/RequestPanel";
import RegisterClient from "../../RegisterClient/RegisterClient";
import { ClientConsents } from "../ClientConsent";
import RequestRecords from "../RequestRecords/RequestRecords";

const DashBoard = () => {
  const [showConsentFormModal, setShowConsentFormModal] = useState(false);
  const [showRegisterScreen, setShowRegisterScreen] = useState(false);
  const [showConsentScreen, setShowConsentScreen] = useState(false);
  const [showRequestRecords, setShowRequestRecords] = useState(false);

  if (showRegisterScreen) {
    return <RegisterClient onBack={() => setShowRegisterScreen(false)} />;
  }

  if (showConsentScreen) {
    return <ClientConsents onBack={() => setShowConsentScreen(false)} />;
  }

  if (showRequestRecords) {
    return <RequestRecords onBack={() => setShowRequestRecords(false)} />;
  }

  return (
    <div className="dashboard">
      <h2>Dashboard</h2>
      <div className="actions-required">
        <div className="action-item clickable">
          <span>0</span> Ready for Payment
        </div>
        <div className="action-item clickable">
          <span>0</span> Pending Direction
        </div>
        <div className="action-item clickable">
          <span>99+</span> Ready for Download
        </div>
        <div className="action-item clickable">
          <span>0</span> New Consent Required
        </div>
        <div className="action-item clickable">
          <span>0</span> Client Signature Required
        </div>
      </div>
      <div className="quick-access">
        <button
          className="clickable"
          onClick={() => setShowConsentFormModal(true)}
        >
          <FaFileDownload /> Download Consent Forms
        </button>
        <button
          className="clickable"
          onClick={() => setShowRegisterScreen(true)}
        >
          <FaUserPlus /> Register New Client
        </button>
        <button
          className="clickable"
          onClick={() => setShowRequestRecords(true)}
        >
          <FaFileAlt /> Request Records
        </button>
        <button
          className="clickable"
          onClick={() => setShowConsentScreen(true)}
        >
          <FaSignature /> Consents
        </button>
      </div>
      <RequestPanel />
      {showConsentFormModal && (
        <ConsentModal onClose={() => setShowConsentFormModal(false)} />
      )}
    </div>
  );
};

export default DashBoard;
